// extracted by mini-css-extract-plugin
module.exports = {"container":"About_container__3yndN","hr":"About_hr__2ckZr","about":"About_about__2P5xE","img":"About_img__30vUu","p":"About_p__1010d"};